import { useQuery } from "@tanstack/react-query";
import useWidgetStore from "../../store/useWidgetStore";
import ConfigHolder from "../../config/ConfigHolder";
import { useSettings } from "../../context/SettingsContext";
export const useProducts = (options) => {
    const { enabled, selectedApptype } = useWidgetStore();
    const { api_key, widget_id } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: enabled.product, networkMode: "online", cacheTime: 60 * 1000 * 10, staleTime: 60 * 1000 * 10 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-product', selectedApptype], queryFn: async ({ signal }) => {
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'products', 'kassa');
            let data = {
                apptypeIds: selectedApptype !== null && selectedApptype !== void 0 ? selectedApptype : [],
                include: ["stock", "required", "payment"]
            };
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    'Content-Type': 'application/json', // checks this header if it's a POST, while calling the method getRestData.... That's not Restful
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/json+ld',
                },
                body: JSON.stringify(data)
            });
            return response.json();
        } }));
};
